import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { animeLibrary } from '@/mocks/animeData';

const weekdayLabels = ['周五更新', '周六更新', '周日更新', '周三更新'];

export default function SeasonSection() {
  const season = animeLibrary.filter((item) => item.isNew);

  return (
    <section id="season" className="w-full py-16 md:py-24">
      <div className="px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="New Season"
            title="新番导视"
            description="当季开播的作品与更新进度集中在这里。挑两三部同步追就够，其余适合等完结后一次补完，不必被更新节奏牵着走。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {season.map((item, index) => (
            <Reveal key={item.id} delay={index * 60}>
              <article className="group h-full flex gap-4 rounded-lg bg-background-100 border border-background-200/70 p-4 hover:border-primary-300 transition-colors">
                <div className="flex-shrink-0 w-24 md:w-28 h-36 md:h-40 rounded-md overflow-hidden bg-background-200">
                  <img
                    src={item.poster}
                    alt={`${item.title} 新番作品封面`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0 flex flex-col">
                  <div className="flex items-center gap-2">
                    <span className="px-2 py-0.5 rounded-full text-[11px] bg-accent-100 text-accent-900">
                      新番
                    </span>
                    <span className="text-[11px] md:text-xs text-foreground-500">
                      {weekdayLabels[index % weekdayLabels.length]}
                    </span>
                  </div>
                  <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-500">{item.genre} · {item.year} 年</p>
                  <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                    {item.summary}
                  </p>
                  <div className="mt-auto pt-3 flex items-center justify-between">
                    <span className="flex items-center gap-1 text-xs md:text-sm text-foreground-700">
                      <i className="ri-progress-4-line text-secondary-600"></i>
                      {item.episodes}
                    </span>
                    <span className="flex items-center gap-1 text-xs md:text-sm text-foreground-700">
                      <i className="ri-star-fill text-accent-500"></i>
                      {item.score}
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-6 flex items-start gap-3 rounded-lg bg-secondary-50 border border-secondary-200/70 p-4 md:p-5">
            <span className="flex-shrink-0 w-9 h-9 rounded-md bg-secondary-500 text-background-50 flex items-center justify-center">
              <i className="ri-calendar-check-line"></i>
            </span>
            <p className="text-xs md:text-sm text-secondary-900 leading-relaxed">
              <strong className="font-medium">追番提醒：</strong>
              新番更新往往集中在周末。若时间有限，建议只同步追两部，其余加入待看清单，等完结后用整块时间补齐，观感会更连贯。
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}